import { z } from 'zod';
import { FuenteMaestro, ModalidadLabor, ModoIntegracion, SistemaNomina, TipoConcepto, TipoContrato, TipoSociedad, TipoUbicacion, } from './enums.js';
import { ConceptoCodigo, LaborCodigo } from './tarifas.js';
const Uuid = z.string().uuid();
const Fecha = z.string().date();
export const RutSchema = z.string().regex(/^[0-9]{1,8}-[0-9K]$/, 'RUT con formato 12345678-9');
export const SociedadInput = z
    .object({
    rut: RutSchema,
    nombre: z.string().min(2).max(200),
    tipo_sociedad: TipoSociedad,
    sociedad_principal_id: Uuid.nullable().optional(),
    registro_contratista_agricola: z.string().nullable().optional(),
    registro_vigente_hasta: Fecha.nullable().optional(),
    sistema_nomina: SistemaNomina,
    modo_integracion: ModoIntegracion,
})
    .refine((s) => s.tipo_sociedad === 'principal' || !!s.registro_contratista_agricola, {
    message: 'registro_contratista_agricola obligatorio para contratistas',
    path: ['registro_contratista_agricola'],
});
export const PersonaInput = z.object({
    rut: RutSchema,
    nombres: z.string().min(1).max(100),
    apellidos: z.string().min(1).max(100),
    fuente_maestro: FuenteMaestro.default('propio'),
    id_en_fuente: z.string().nullable().optional(),
});
export const VinculoInput = z.object({
    persona_id: Uuid,
    sociedad_id: Uuid,
    desde: Fecha,
    hasta: Fecha.nullable(),
    tipo_contrato: TipoContrato,
    faena: z.string().nullable().optional(),
    jornada_pactada_horas: z.number().positive().max(60),
    id_en_nomina: z.string().nullable().optional(),
    centro_costo: z.string().nullable().optional(),
    fuente: z.string().default('propio'),
});
export const UbicacionInput = z.object({
    sociedad_id: Uuid,
    tipo: TipoUbicacion,
    padre_id: Uuid.nullable().optional(),
    codigo: z.string().min(1).max(40),
    nombre: z.string().min(1).max(200),
    atributos: z.record(z.string(), z.unknown()).default({}),
    objeto_costo: z.string().nullable().optional(),
    desde: Fecha,
    hasta: Fecha.nullable().optional(),
});
export const LaborInput = z.object({
    labor_codigo: LaborCodigo,
    nombre: z.string().min(2),
    modalidad: ModalidadLabor,
    unidad: z.string().nullable().optional(),
    exige_cuartel: z.boolean().default(true),
    exige_calidad: z.boolean().default(false),
    tope_diario: z.number().positive().nullable().optional(),
    concepto_codigo: ConceptoCodigo,
    ventana_aceptacion_dias: z.number().int().min(0).max(60).default(7),
});
export const ConceptoInput = z
    .object({
    concepto_codigo: ConceptoCodigo,
    nombre: z.string().min(2),
    tipo: TipoConcepto,
    devengo_diario: z.boolean(),
    fundamento_devengo_diario: z.string().nullable().optional(),
    incide_en: z.array(z.string()).min(1),
    principalidad: z.enum(['principal', 'accesorio']).nullable().optional(),
    ordinariedad: z.enum(['ordinario', 'extraordinario']).nullable().optional(),
    desde: Fecha,
    hasta: Fecha.nullable().optional(),
})
    .refine((c) => !c.devengo_diario || !!c.fundamento_devengo_diario, {
    message: 'devengo_diario requiere fundamento',
    path: ['fundamento_devengo_diario'],
});
//# sourceMappingURL=maestros.js.map